import { createLookupHook } from "./createLookupHook";
type GeneralLookups = unknown

export const useGeneralLookups = createLookupHook<GeneralLookups>(
  "general",
  "/lookups/general",
);
